<template>
    <div>
        <div class="page-head">
            <a-icon @click="$router.go(-1)" type="left-square" theme="filled"/>
            <a-breadcrumb>
                <a-breadcrumb-item>首页</a-breadcrumb-item>
                <a-breadcrumb-item><a href="javascript:;">财务管理</a></a-breadcrumb-item>
                <a-breadcrumb-item><a href="javascript:;">退款管理</a></a-breadcrumb-item>
            </a-breadcrumb>
        </div>

         <div class="clue-search">
            <div class="left">
                <!-- <a-range-picker :locale="locale" @change="ondateChange" /> -->
                <a-select style="width: 120px" allowClear @change="typehandleChange" placeholder="支付状态" :showArrow="show">
                    <a-select-option v-for="(option,x) in typeoption" :key="x" :value="option.id">
                        {{option.name}}
                    </a-select-option>
                </a-select>

                 <a-select style="width: 120px" allowClear @change="jhhandleChange" placeholder="激活状态" :showArrow="show">
                    <a-select-option v-for="(option,x) in jhoption" :key="x" :value="option.id">
                        {{option.name}}
                    </a-select-option>
                </a-select>

                <a-select style="width: 120px" allowClear @change="payhandleChange" placeholder="支付方式" :showArrow="show">
                    <a-select-option v-for="(option,x) in payoption" :key="x" :value="option.id">
                        {{option.name}}
                    </a-select-option>
                </a-select>
                 <!-- 日期 -->
                <a-range-picker style="width:260px" :locale="locale" @change="ondateChange" />

                <a-button @click="exportmodal" type="primary" icon="upload">导出</a-button>
            </div>
            <!-- 来源 -->

            <div class="right" style="display:flex">

                <a-input v-model="telephone_jh" style="width:160px;margin-right:6px" placeholder="激活号码"></a-input>
                <a-input-search
                    placeholder="关键字(用户名/订单号)"
                    enter-button="查询"
                    @search="onSearch"
                    v-model="searchtext"
                    >
                </a-input-search>
            </div>
             
        </div>

        <div class="data-list">
            <a-spin :spinning="tablespinning">
                <a-table  rowKey="orid" :scroll="{x: 1100}" :pagination="pageshow" :columns="columns" :data-source="data">
                    <span slot="date" slot-scope="text">
                        <span v-if="text">{{text | formatDate }}</span>
                        <span v-else>--</span>
                    </span>

                    <!-- <span slot="datetime" slot-scope="text">
                        <span v-if="text">{{text | showDate }}</span>
                        <span v-else>--</span>
                    </span> -->

                    <span slot="status" slot-scope="text">
                        <a-tag v-if="text==0" color="orange">未支付</a-tag>
                        <a-tag v-if="text==1" color="blue">已支付</a-tag>
                        <a-tag v-if="text==3" color="green">已退款</a-tag>
                    </span>

                    <span slot="paystatus" slot-scope="text">
                       <span style="font-size:18px;color:#1890ff"><a-icon v-if="text==1" type="alipay-circle" /></span>
                       <span style="font-size:18px;color:#52c41a"><a-icon v-if="text==2" type="wechat" /></span>
                        <!-- <a-tag v-if="text==1" color="blue">支付宝</a-tag>
                        <a-tag v-if="text==2" color="green">微信</a-tag> -->
                    </span>

                    <span slot="phone" slot-scope="text">
                        <a style="display:block" v-for="item,i in text" :key="i" target="_blank" :href="item.url">{{item.telephone}}</a>
                    </span>

                    <span slot="jhstuats" slot-scope="text">
                        <a-tag v-if="text=='未激活'" color="orange">未激活</a-tag>
                        <a-tag v-if="text=='已激活'" color="green">已激活</a-tag>
                    </span>

                    <span slot="action" slot-scope="text,record">
                        <a href="javascript::" :disabled="record.state_pay==3?true:false" @click="torefund(record.orid)"><a-icon type="transaction"/> 退款</a>
                    </span>
                </a-table>

                <div style="padding-top:30px;width: auto;display: flex;align-items: center;justify-content: flex-start;margin: 15px 12px 12px;">
                    <div class="page-total">总计：{{pagination.total}}条 / {{totalpage}}页</div>
                    <a-pagination
                    show-size-changer
                    :default-current="1"
                    :page-size-options="pageSizeOptions"
                    :total="pagination.total"
                    :defaultPageSize="10"
                    @change="handleTableChange"
                    @showSizeChange="onShowSizeChange"
                    >
                        <template slot="buildOptionText" slot-scope="props">
                            <span>{{ props.value }}条/页</span>
                        </template>

                    </a-pagination>
                </div>
            </a-spin>
        </div>

        <!-- 退款 -->

        <a-modal
        title="退款"
        :visible="tkvisible"
        @cancel="handleCancel"
        cancelText="取消"
        okText="确定"
        @ok="tkhandleOk"
        >
            <a-form name="editform" class="dataform" :label-col="{ span: 4 }" :wrapper-col="{ span: 16 }">
                 <a-form-item label="退款原因">
                      <a-select  style="width: 260px" @change="handleChange" placeholder="请选择退款原因">
                        <a-select-option :value="item.rftid" v-for="item in tklist" :key="item.rftid">
                            {{item.title}}
                        </a-select-option>
                    </a-select>
                </a-form-item>
            </a-form>
        </a-modal>

        <!-- 导出数据 -->
        <a-modal
            title="导出数据"
            :visible="exportvisible"
            :confirm-loading="confirmLoading"
            @cancel="handleCancel"
            :footer="null"
            >
            <div class="import-text">
                <a-spin :spinning="spinning">
                    <div class="export-content" >
                        <svg width="54px" height="54px" viewBox="0 0 54 54" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" style="width: 54px; height: 54px; margin-bottom: 12px;">
                            <g id="页面-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="Artboard-Copy-83"><circle id="Oval-12" fill="#33B028" cx="27" cy="27" r="27"></circle><polyline id="Path-9" stroke="#FFFFFF" stroke-width="6" stroke-linecap="round" stroke-linejoin="round" points="14 28.6835304 22.5324773 37 41 19"></polyline></g></g>
                        </svg> 
                        <h4>批量导出已完成</h4>
                        <!-- <p>线索导出已完成,导出数据量{{totalnum}}条，下载导出文件。</p> -->
                        <a class="export-btn" :href="exporturl" download>
                            <svg width="20px" height="20px" viewBox="0 0 20 20" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink">
                                <g id="页面-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="Icon-color-2"><rect id="矩形" x="0" y="0" width="20" height="20"></rect><circle id="椭圆形" fill="#4F7AFD" cx="10" cy="10" r="7"></circle><path d="M13.7874223,8.70748256 L10.6082602,6.24464133 C10.4561396,6.09636616 10.2413392,6 9.99995555,6 C9.75857185,6 9.54386039,6.09636616 9.39422917,6.24616557 L6.20991046,8.70570428 C6.08170594,8.83831359 6,9.0096218 6,9.19955966 C6,9.60729521 6.36647646,9.93788702 6.81821516,9.93788702 C6.82452759,9.93788702 6.8306622,9.93712489 6.83688572,9.93695553 L6.83688572,9.94161295 L8.66634397,9.94161295 L8.66634397,14 L11.3335671,14 L11.3335671,9.94161295 L13.1331525,9.94161295 L13.1331525,9.93568533 C13.1493336,9.93653213 13.1652481,9.93805638 13.1817848,9.93805638 C13.6336124,9.93805638 14,9.60737989 14,9.19955966 C14,9.0096218 13.9182052,8.83839827 13.7874223,8.70748256 Z" id="路径" fill="#FFFFFF" fill-rule="nonzero" transform="translate(10.000000, 10.000000) rotate(-180.000000) translate(-10.000000, -10.000000) "></path><rect id="矩形" fill="#4F7AFD" x="8" y="7" width="4" height="1"></rect></g></g>
                            </svg>
                            <span>下载导出文件</span>
                        </a>
                    </div>
                </a-spin>
            </div>
        </a-modal>
    </div>
</template>

<script>
import locale from 'ant-design-vue/es/date-picker/locale/zh_CN';
import moment from 'moment'
import {formatDate} from '../../utils/formate.js'
const columns = [
    {title: 'ID',dataIndex: 'orid',key: 'orid',fixed: 'left',width:90},
    {title: '订单编号',dataIndex: 'orderno',key: 'orderno',width:170},
    {title: '交易单号',dataIndex: 'trade_no',key: 'trade_no',width:200},
    {title: '激活号码',dataIndex: 'telephones',key: 'telephones',width:160,scopedSlots: { customRender: 'phone' }},
    {title: '买家姓名',dataIndex: 'username',key: 'username',width:100},
    {title: '退款金额',dataIndex: 'amount',key: 'amount',width:100},
    {title: '激活状态',dataIndex: 'state_jh',key: 'state_jh',scopedSlots: { customRender: 'jhstuats' },width:120},
    {title: '激活时间',dataIndex: 'openDate',key: 'openDate',width:120},
    {title: '退款原因',dataIndex: 'refund_title',key: 'refund_title',width:130},
    {title: '退款状态',dataIndex: 'state_pay',key: 'state_pay',scopedSlots: { customRender: 'status' },width:120},
    {title: '支付方式',dataIndex:'pay_type',key: 'pay_type',scopedSlots: { customRender: 'paystatus' },width:100},
    {title: '退款时间',dataIndex: 'updatetime',key: 'updatetime',scopedSlots: { customRender: 'date' },width:120},
    {title: '操作',key: 'action',scopedSlots: { customRender: 'action' },width:110,fixed: 'right',}
];
export default {
    filters: {
      //年-月-日
        formatDate (time) {
            time = time * 1000
            let date = new Date(time)
            return formatDate (date, 'yyyy-MM-dd')
        }
    },

    data(){
        return{
            locale,
            tablespinning:true,
            columns,
            data:[],
            pagination:{
                total:20
            },
            show:true,
            totalpage:2,
            pageshow:false,
            currentpagination:"",
            pageSizeOptions:['10','20','30','40','100','200'],
            size:10,
            payoption:[{name:'全部',id:""},{name:'微信',id:"2"},{name:'支付宝',id:"1"}],
            typeoption:[{name:'全部',id:""},{name:'已支付',id:"1"},{name:'已退款',id:"3"}],
            state_pay:"",
            jhoption:[{name:'全部',id:""},{name:'已激活',id:"1"},{name:'未激活',id:"2"}],
            state_jh:"",

            searchtext:"",
            tkvisible:false,

            tklist:[],
            orid:"",
            rftid:"",

            telephone_jh:"",

            exportvisible:false,
            spinning:true,
            exporturl:"",

            starttime:"",
            endtime:"",

            pay_type:""
        }
    },
    mounted(){
        this.fetch()
        this.gettklist()
    },
    methods:{
        // 导出
        exportmodal(){
            this.exportvisible=true
            this.spinning=true
            this.$axios.post("/api/order/orderrefundlink",{
                state_pay:this.state_pay,
                state_jh:this.state_jh,
                search:this.searchtext,
                telephone_jh:this.telephone_jh,
                starttime:this.starttime,
                endtime:this.endtime,
                pay_type:this.pay_type
            },{
                headers: {
                    "token":localStorage.getItem('token'),
                }
            }).then((res)=>{
                if(res.data.code==200){
                    this.spinning=false
                    // this.exportload=false
                    this.exporturl=res.data.data.url
                }
            })
        },
        handleCancel(){
            this.tkvisible=false
            this.exportvisible=false
        },
        ondateChange(date,dateString){
            this.currentpage=1
            this.starttime=moment(dateString[0]+' 00:00:01').unix()
            this.endtime=moment(dateString[1]+' 23:59:59').unix()
            this.fetch()
        },

        payhandleChange(value){
            this.pay_type=value
            this.fetch()
        },

        onSearch(){
            this.fetch()
        },

        // 退款
        handleChange(value){

            this.rftid=value
        },
        torefund(id){
            this.tkvisible=true
            this.orid=id
        },
        tkhandleOk(){
           this.$axios.post('/api/order/orderrefund',{
                orid: this.orid,
                state_pay:3,
                rftid:this.rftid
            },{
                headers: {
                    "token":localStorage.getItem('token'),
                }
            }).then((res)=>{
                if(res.data.code==200){
                    this.$message.success(res.data.msg); 
                    this.tkvisible=false
                    this.fetch()
                }else{
                    this.$message.warning(res.data.msg); 
                }
               
            }) 
        },

         // 分页
        handleTableChange(pageNumber) {
            this.currentpage=pageNumber
            this.fetch();
        },
        onShowSizeChange(current,pageSize){
            this.size=pageSize
            this.page=1
            this.fetch();
        },

        // 退款原因
        gettklist(){
            this.$axios.post('/api/system/refundtaglist',{
                pagesize: 20
            },{
                headers: {
                    "token":localStorage.getItem('token'),
                }
            }).then((res)=>{
                if(res.data.code==200){
                    var data=res.data.data.data
                    this.tklist=data
                }else{
                    this.$message.warning(res.data.msg); 
                }
               
            })
        },

         // 标签筛选
        typehandleChange(value){
            this.currentpage=1
            this.state_pay=value
            this.fetch()
        },
        jhhandleChange(value){
            this.currentpage=1
            this.state_jh=value
            this.fetch()
        },

        // 数据
        fetch(){
            this.$axios.post('/api/order/orderrefundlist',{
                pagesize: this.size,
                page:this.currentpage,
                state_pay:this.state_pay,
                state_jh:this.state_jh,
                search:this.searchtext,
                telephone_jh:this.telephone_jh,
                starttime:this.starttime,
                endtime:this.endtime,
                 pay_type:this.pay_type
            },{
                headers: {
                    "token":localStorage.getItem('token'),
                }
            }).then((res)=>{
                if(res.data.code==200){
                    this.tablespinning=false
                    const pagination = { ...this.pagination };
                    pagination.total = res.data.data.total;
                    pagination.pageSize=this.size
                    var data=res.data.data.data
                    for(var i in data){
                        data[i].telephones=JSON.parse(data[i].telephones)
                    }
                    this.data=data
                    this.pagination = pagination;
                    this.totalpage=Math.ceil(res.data.data.total/this.size)
                }else{

                }
               
            })
        },
    }
}
</script>


// WEBPACK FOOTER //
// src/components/finance/refundlist.vue